import React from 'react';
import { getTranslatedString } from 'helpers/i18n';
import styled from 'styled-components';
import { formatMoney } from 'helpers/Formatter';
import {
  Card,
  Header,
  Body,
  BoldTitle,
  BoldText,
  GreyText,
  VerticalDivider,
  HorizontalDivider,
  MobileItem,
} from '../common/Card';
import MediaQuery from 'react-responsive';

const StyledBodyItem = styled.div`
  text-align: ${props => props.textAlign || 'left'};
`;

const RenewalProposalCard = ({
  index,
  leaseStartDate,
  leaseEndDate,
  selectedLeaseTerm,
  rent,
  special,
  other,
}) => {
  const sum = (rent, special, other) => {
    // Rental amouts come from yardi as strings I.E.
    // rent: '1095.000000',
    // special: '-30.000000',
    // other: '0.000000'
    return formatMoney(
      [rent, special, other].reduce((prev, current) => parseFloat(prev) + parseFloat(current))
    );
  };

  return (
    <React.Fragment>
      <MediaQuery query="(min-device-width: 750px)">
        <Card>
          <Header>
            <BoldTitle>
              {getTranslatedString('landlordPortal.rentRoll.renewals.renewalProposal')}
            </BoldTitle>
          </Header>
          <HorizontalDivider />
          <Body>
            <StyledBodyItem>
              <GreyText>
                {getTranslatedString('landlordPortal.rentRoll.renewals.startDate')}
              </GreyText>
              <BoldText>{leaseStartDate}</BoldText>
            </StyledBodyItem>
            <VerticalDivider />
            <StyledBodyItem textAlign="center">
              <GreyText>{getTranslatedString('landlordPortal.rentRoll.renewals.endDate')}</GreyText>
              <BoldText>{leaseEndDate}</BoldText>
            </StyledBodyItem>
            <VerticalDivider />
            <StyledBodyItem textAlign="right">
              <GreyText>
                {getTranslatedString('landlordPortal.rentRoll.renewals.leaseTerms')}
              </GreyText>
              <BoldText>
                {getTranslatedString('landlordPortal.rentRoll.renewals.months', {
                  term: selectedLeaseTerm,
                })}
              </BoldText>
            </StyledBodyItem>
          </Body>
        </Card>
      </MediaQuery>

      <MediaQuery query="(max-device-width: 750px)">
        <Card>
          <Header>
            <BoldTitle>
              {getTranslatedString('landlordPortal.rentRoll.renewals.renewalProposal')}
            </BoldTitle>
          </Header>
          <HorizontalDivider />
          <Body>
            <MobileItem borderRight>
              <GreyText>
                {getTranslatedString('landlordPortal.rentRoll.renewals.startDate')}
              </GreyText>
              <BoldText>{leaseStartDate}</BoldText>
            </MobileItem>
            <MobileItem textAlign="right">
              <GreyText>{getTranslatedString('landlordPortal.rentRoll.renewals.endDate')}</GreyText>
              <BoldText>{leaseEndDate}</BoldText>
            </MobileItem>
          </Body>
          <HorizontalDivider />
          <Body>
            <MobileItem borderRight>
              <GreyText>
                {getTranslatedString('landlordPortal.rentRoll.renewals.monthlyRent')}
              </GreyText>
              <BoldText>{sum(rent, special, other)}</BoldText>
            </MobileItem>
            <MobileItem textAlign="right">
              <GreyText>
                {getTranslatedString('landlordPortal.rentRoll.renewals.leaseTerms')}
              </GreyText>
              <BoldText>
                {getTranslatedString('landlordPortal.rentRoll.renewals.months', {
                  term: selectedLeaseTerm,
                })}
              </BoldText>
            </MobileItem>
          </Body>
        </Card>
      </MediaQuery>
    </React.Fragment>
  );
};

export default RenewalProposalCard;
